<template>
  <div id="productList">
    <ProductRecommList />
    <ProductList />
  </div>
</template>

<script>
import ProductRecommList from '@/components/product/ProductRecommList.vue';
import ProductList from '@/components/product/ProductList.vue';

export default {
  name: 'ProductMain',
  components: {
    ProductRecommList,
    ProductList,
  },
  props: [],
  data() {
    return {};
  },
  methods: {},
  created() {
    this.$store.dispatch('getProductItems', this.pgDiv);
  },
};
</script>
